import { useContext } from "@/common/hooks";
import { PrivateContext } from "@/routes/PrivateRoute";
import { Titlebar, Navbar, SubNavbar } from "@/common/components";

const GridLayout = ({ children }) => {
  const {
    subNavHeader,
    subNavButtonText,
    subNavButtonClick,
    redirectTo,
    isRiccAdministrator,
    showChangeProductManufacturer,
    accessorDetails,
    productSponsorName,
    navCancelFunc,
    printRef,
    accessProfileId,
  } = useContext(PrivateContext);

  return (
    <>
      <Titlebar
        redirectTo={redirectTo}
        showChangeProductManufacturer={showChangeProductManufacturer}
        accessorDetails={accessorDetails}
        productSponsorName={productSponsorName}
        wrapperClassName="d-md-block d-none"
      />
      <Navbar
        type="private"
        redirectTo={redirectTo}
        isRiccAdministrator={isRiccAdministrator}
        accessProfileId={accessProfileId}
        navCancelFunc={navCancelFunc}
      />
      <Titlebar
        redirectTo={redirectTo}
        showChangeProductManufacturer={false}
        accessorDetails={accessorDetails}
        productSponsorName={productSponsorName}
        showLogout={false}
        wrapperClassName="d-md-none"
      />
      <SubNavbar
        header={subNavHeader}
        buttonText={subNavButtonText}
        buttonClick={subNavButtonClick}
      />
      <main className="container" ref={printRef}>
        {children}
      </main>
    </>
  );
};

export default GridLayout;
